import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=f88e6036&scoped=true&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=f88e6036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88e6036",
  null
  
)

export default component.exports